import { render, staticRenderFns } from "./UnscheduledTreatmentSkeleton.vue?vue&type=template&id=491af952&scoped=true"
import script from "./UnscheduledTreatmentSkeleton.vue?vue&type=script&lang=js"
export * from "./UnscheduledTreatmentSkeleton.vue?vue&type=script&lang=js"
import style0 from "./UnscheduledTreatmentSkeleton.vue?vue&type=style&index=0&id=491af952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491af952",
  null
  
)

export default component.exports